import {
  CHANGE_RECEIVE_ADDRESS_EVENT,
  REFRESH_RECEIVE_ADDRESS_EVENT,
  REFRESH_WALLET_DETAIL_EVENT,
} from '@/constants/event'
import { useEffect, useState, useMemo, useCallback } from 'react'
import emitter from '@/utils/event'
import {
  ReceiveAddressGroupItem,
  AddrType,
  AddressListPageModel,
} from '@/services/apis/address/models'
import addressApi from '@/services/apis/address'
import { getAddrTypeName } from '@/utils/address'
import { AssertUrl } from '@/services/apis/address/models'

export const useCurrentReceiveAddressGroup = (walletKey: string, coinKey: string) => {
  const [addressGroup, setAddressGroup] = useState<ReceiveAddressGroupItem>()
  const [activeAddressType, setActiveAddressType] = useState<AddrType>('P2PKH')

  useEffect(() => {
    addressApi
      .getFirstReceiveAddressGroup({
        accountKey: walletKey,
        coinKey,
      })
      .then(res => {
        setAddressGroup(res.data)
        setActiveAddressType(res.data.addressList ? res.data.addressList[0].addressType : 'P2PKH')
      })
  }, [walletKey, coinKey])

  useEffect(() => {
    const fn = (data: ReceiveAddressGroupItem) => {
      setAddressGroup(data)
      setActiveAddressType(data.addressList ? data.addressList[0].addressType : 'P2PKH')
    }
    emitter.on(CHANGE_RECEIVE_ADDRESS_EVENT, fn)
    return () => emitter.off(REFRESH_WALLET_DETAIL_EVENT, fn)
  }, [])

  const addressTabs = useMemo(() => {
    return addressGroup?.addressList?.map?.(item => {
      return {
        label: getAddrTypeName(item?.addressType),
        key: item?.addressType,
      }
    })
  }, [addressGroup])

  const currAddr = useMemo(
    () =>
      addressGroup?.addressList?.find?.(item => item.addressType === activeAddressType)?.address ??
      '',
    [addressGroup, activeAddressType]
  )

  return {
    currAddr,
    addressGroup,
    addressTabs,
    activeAddressType,
    setActiveAddressType,
  }
}

export const useGetGroupAddressList = (walletkey: string, coinKey: string) => {
  const [data, setData] = useState<AddressListPageModel>()
  const [loading, setLoading] = useState<boolean>(false)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const cb = useCallback((pageNum: number) => {
    setLoading(true)
    addressApi
      .getGroupAddressList({
        accountKey: walletkey,
        coinKey,
        pageNumber: pageNum,
      })
      .then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])
  useEffect(() => cb(currentPage), [walletkey, coinKey, currentPage])
  useEffect(() => {
    const fn = () => {
      setCurrentPage(1)
      cb(1)
    }
    emitter.on(REFRESH_RECEIVE_ADDRESS_EVENT, fn)
    return () => {
      emitter.off(REFRESH_RECEIVE_ADDRESS_EVENT, fn)
    }
  }, [])
  return {
    data,
    loading,
    currentPage,
    setCurrentPage,
  }
}

export const useAssertUrlList = () => {
  const [data, setData] = useState<AssertUrl[]>()
  useEffect(() => {
    addressApi.getAssertUrlList().then(res => {
      if (res.success) {
        setData(res.data)
      }
    })
  }, [])
  return data
}
